import React, { FC } from 'react';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { Negrito } from '../Tipografia/Texto';
import { Details, ResponseError } from './ErroServidor.utils';
import { MensagensErroServidorView } from './MensagensErroServidorView';

interface MensagensErrosDeNegocioServidorProps {
  erro: ResponseError;
  className?: string;
}

export const MensagensErrosDeNegocioServidor: FC<MensagensErrosDeNegocioServidorProps> = ({erro, className}) => {
  const tituloPadrao = "Caro usuário, ocorreram os seguintes erros:";

  const titulo = erro.data?.message ?? tituloPadrao;
  const erros = erro.data?.details.map((it, indice) => <li key={indice}><MensagemErroNegocioServidor mensagem={it} /></li>) ?? []

  return <MensagensErroServidorView
      className={className}
      aparencia="error"
      titulo={titulo}
    >
    {erros.length > 0 && <UL>{erros}</UL>}
  </MensagensErroServidorView>
}

const UL = styled.ul`
  margin-top: ${Spacing.unit}px;
  margin-bottom: 0;
`;



interface MensagemErroNegocioServidorProps {
  mensagem: Details;
}

export const MensagemErroNegocioServidor: FC<MensagemErroNegocioServidorProps> = ({mensagem}) => {
  const subTitulo = mensagem.element
    ? <><Negrito>{mensagem.element}</Negrito>: </>
    : <></>;

  return <>{subTitulo}{mensagem.message}</>;
}
